export default "__VITE_ASSET__DSeq$HAu__"